import type { ReactNode } from 'react';

import { Text } from '@actual-app/components/text';

import { color } from '#components/mobile/ui/tokens';

/** Rótulo pequeño en mayúsculas encima de una lista («A bordo · 3»). */
export function RotuloLista({ children }: { children: ReactNode }) {
  return (
    <Text
      style={{
        fontSize: 12.5,
        fontWeight: 800,
        color: color.fg3,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        margin: '4px 2px -6px',
        flexShrink: 0,
      }}
    >
      {children}
    </Text>
  );
}
